/**
 * Maps connector vars field keys to the display labels used in the version-history diff view. This
 * is the SOURCE OF TRUTH for those labels, but the connector forms still duplicate them in their
 * JSX, so the two can drift until the forms are refactored to consume this registry. Covers the
 * union of top-level vars fields across every connector form and `baseUrl`.
 */
const CONNECTOR_FIELD_LABELS: Record<string, string> = {
  // Common across many connectors
  baseUrl: "Base URL",
  apiKey: "API Key",
  tables: "Tables",
  schedules: "Schedules",
  bronzeDataset: "Bronze Dataset",
  silverDataset: "Silver Dataset",

  // PowerSchools / PowerSchool Enrollment (no unique vars beyond the common set)

  // Skyward
  entityId: "Entity ID",
  entityIds: "Entity IDs",

  // DeansList
  domain: "Domain",
  lookbackDays: "Lookback Days",
  maxDaysPerRequest: "Max Days Per Request",

  // SchoolMint (SFTP)
  accountEmail: "Account Email",
  siteName: "Site Name",
  sftpUsername: "SFTP Username",
  gcsBucketOverride: "GCS Bucket Override",
  gcsPrefixOverride: "GCS Prefix Override",
  pollIntervalMs: "Poll Interval (ms)",
  pollMaxAttempts: "Poll Max Attempts",

  // iReady SFTP
  projectId: "GCP Project ID",
  region: "Region",
  host: "SFTP Host",
  port: "SFTP Port",
  username: "Username",
  sftpWrapperUrl: "SFTP Wrapper URL",
};

/** Looks up a label, falling back to a humanized version of the key. */
export function fieldLabel(key: string): string {
  return CONNECTOR_FIELD_LABELS[key] ?? humanize(key);
}

function humanize(key: string): string {
  // baseUrl -> Base URL; max_retries -> Max Retries
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/[_-]/g, " ")
    .replace(/\s+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}
